module.exports = __webpack_public_path__ + "assets/media/marker2.6a94aff3.svg";